import { useState, useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';

import { Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Link } from '@mui/material';
import { ChangeOfPurposeFiler } from '../../../../../types/filers/changeOfPurposeFiler';


const ChangeOfPurposeList = (): JSX.Element => {

    const [filers, setFilers] = useState<ChangeOfPurposeFiler[]>([]);
    const { showBoundary } = useErrorBoundary();  

    useEffect(() => {
        getRecentlyOrganized();
    }, [])

    const getRecentlyOrganized = async () => {

        try{
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/filers/changesOfPurpose`)
            .then(result => {
            if (!result.ok) {
                showBoundary(new Error('Failed to get recently organized change of purpose candidate list.'));
            }
            return result.json();
        })
        .then(result => {

            let filers: ChangeOfPurposeFiler[] = result;
            setFilers(filers);
            return;
        });
        }catch(error){
            console.error('Uncaught Error:', error);
        }
    }

    
    return (
        <Box marginTop={4}>
             <TableContainer>
                <Table aria-label="Change of Purpose table" size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{width: 80}}>
                                <Typography variant={'subtitle1'} fontWeight={600}>
                                     CPF ID
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'subtitle1'} fontWeight={600}>
                                     Name/Address
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'subtitle1'} fontWeight={600}>
                                    Old Office Sought
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'subtitle1'} fontWeight={600}>
                                    New Office Sought
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'subtitle1'} fontWeight={600}>
                                     Changed On
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filers?.map((filer, index) => (
                        <TableRow
                            key={index}
                            sx={{
                                '&:last-child td, &:last-child th': { border: 0 },
                                '&:nth-of-type(odd)': {
                                    backgroundColor: '#fafafa',
                                  },
                            }}
                        >
                            <TableCell>
                                <Typography variant={'subtitle1'} component={Link} href={`/Filers?q=${filer.cpfId}`} underline="none">
                                    {filer.cpfId}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'subtitle1'} fontWeight={550}>
                                    {filer.fullNameReverse}
                                </Typography>
                                <Typography color={'text.secondary'} component={'i'} variant={'subtitle2'}>
                                    {filer.fullAddress}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'subtitle1'}>
                                    {filer.oldOfficeDistrict}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'subtitle1'}>
                                    {filer.newOfficeDistrict}
                                </Typography>
                            </TableCell>
                            <TableCell width={120}>
                                <Typography variant={'subtitle1'}>
                                    {filer.date}
                                </Typography>
                            </TableCell>
                        </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default ChangeOfPurposeList;